import React from "react";
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  Paper,
} from "@mui/material";
import {
  Description as TemplateIcon,
  Campaign as BroadcastIcon,
} from "@mui/icons-material";

const BroadcastNavigation = ({ activeSection, onSectionChange }) => {
  const sections = [
    {
      id: "templates",
      label: "Templates",
      icon: <TemplateIcon />,
    },
    {
      id: "broadcast-messages",
      label: "Broadcast Messages",
      icon: <BroadcastIcon />,
    },
  ];

  return (
    <Paper
      elevation={0}
      sx={{
        height: "100%",
        borderRight: "1px solid #e0e0e0",
        backgroundColor: "#fafafa",
      }}
    >
      {/* Header */}
      <Box sx={{ p: 3, borderBottom: "1px solid #e0e0e0" }}>
        <Typography variant="h6" sx={{ fontWeight: 600, color: "#333" }}>
          Broadcast
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
          Manage templates and campaigns
        </Typography>
      </Box>

      {/* Navigation List */}
      <List sx={{ pt: 1 }}>
        {sections.map((section) => {
          const isActive = activeSection === section.id;
          return (
            <ListItem key={section.id} disablePadding>
              <ListItemButton
                onClick={() => onSectionChange(section.id)}
                sx={{
                  mx: 1,
                  mb: 0.5,
                  borderRadius: 2,
                  backgroundColor: isActive ? "#e3f2fd" : "transparent",
                  color: isActive ? "#1976d2" : "#666",
                  "&:hover": {
                    backgroundColor: isActive ? "#e3f2fd" : "#f0f0f0",
                  },
                  "&::before": isActive
                    ? {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: 0,
                        bottom: 0,
                        width: 4,
                        backgroundColor: "#1976d2",
                        borderRadius: "0 2px 2px 0",
                      }
                    : {},
                }}
              >
                <ListItemIcon
                  sx={{
                    color: isActive ? "#1976d2" : "#666",
                    minWidth: 40,
                  }}
                >
                  {section.icon}
                </ListItemIcon>
                <ListItemText
                  primary={section.label}
                  sx={{
                    "& .MuiListItemText-primary": {
                      fontWeight: isActive ? 600 : 500,
                      fontSize: "14px",
                    },
                  }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
      </List>
    </Paper>
  );
};

export default BroadcastNavigation;
